export default "__VITE_ASSET__Xmmg0Ila__"